import type { VNode } from "preact";

interface HeaderProps {
  children?: VNode | VNode[];
  className?: string;
}

export function Header({ children, className = "" }: HeaderProps): VNode {
  return (
    <header
      className={`h-24 sm:h-28 2xl:h-[140px] w-full flex-shrink-0 px-5 sm:px-8 2xl:px-12 flex items-center ${className}`}
    >
      {children}
    </header>
  );
}
